import * as React from 'react';
import { Button, ButtonProps, Loading } from '@nextui-org/react';

interface AppLoadingButtonProps extends ButtonProps {
  children?: React.ReactNode;
  loading?: boolean;
}

/**
 * @name AppLoadingButton
 * @description tbd...
 */
export function AppLoadingButton(props: AppLoadingButtonProps) {
  const { children, icon, iconRight, loading } = props;

  return (
    <Button
      {...props}
      disabled={loading}
      icon={loading ? undefined : icon}
      iconRight={loading ? undefined : iconRight}
    >
      {loading ? (
        <Loading color="currentColor" type="points-opacity" size="sm" />
      ) : (
        children
      )}
    </Button>
  );
}
